import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from "../hooks/useAuth";
import './Login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login, sessionExpired } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError('');

  try {
    const res = await fetch(
      process.env.REACT_APP_API_URL + "/api/auth/login",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email,
          password
        })
      }
    );

    // Verificar si la respuesta es JSON
    const contentType = res.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      throw new Error("Error del servidor. Por favor, contacte al administrador.");
    }

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || "Error al iniciar sesión");
    }

    // guardar token y usuario usando el método login del contexto
    login(data.user, data.token);

    navigate("/");

  } catch (err) {
    console.error("Error de login:", err);
    setError(err.message || "Error de conexión con el servidor");
  }

  setLoading(false);
};

  return (
    <div className="login-page">
      {/* Fondo SVG */}
      <div className="bg-svg" style={{ backgroundImage: "url('/fondo-web-aileth.png')" }} />

      {/* Overlay */}
      <div className="overlay" />

      {/* tarjeta */}
      <div className="login-card">
        {/* Logo dentro del contenedor */}
        <div className="logo-wrapper">
          <img src="/logo-ai-leth-software-contable-login.png" alt="Ai-leth" onError={(e) => { e.target.onerror = null; e.target.src = "/logo-aileth-nuevo.png"; }} />
        </div>

        <h2>Iniciar Sesión</h2>

        {sessionExpired && (
          <div className="error" style={{ backgroundColor: '#fff3cd', color: '#856404', border: '1px solid #ffc107' }}>
            Su sesión ha expirado. Por favor, inicie sesión nuevamente.
          </div>
        )}

        {error && <div className="error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <label>Correo electrónico</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="ejemplo@correo.com"
          />

          <label>Contraseña</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />

          <div className="extras">
            <label>
              <input type="checkbox" /> Recordarme
            </label>
          </div>

          <button disabled={loading}>
            {loading ? 'Cargando...' : 'Iniciar Sesión'}
          </button>
        </form>
      </div>


    </div>
  );
}
